import { Component, Input, input } from "@angular/core";
import { NgClass } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";

@Component({
	selector: "stages-navigation-entry-two-line",
	templateUrl: "./two-line-navigation-entry.component.html",
	styleUrls: ["./two-line-navigation-entry.component.scss"],
	imports: [TranslateModule, NgClass],
})
export class TwoLineNavigationEntryComponent {
	// TODO: Skipped for migration because:
	//  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
	//  and migrating would break narrowing currently.
	@Input()
	entry!: TwoLineEntry;

	readonly mode = input<NAV_ENTRY_DISPLAY_MODE>();
}
